import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { CommonButton, CommonModal } from "../Input";

const InfoBlock = ({ label, value, showCopy = false }) => (
  <div className="mb-3 ps-2">
    <div className="text-muted fs-11 mb-1 fw-medium">{label}</div>
    <div className="d-flex align-items-center">
      <span className="fw-bold text-black fs-13">{value || "--"}</span>
      {showCopy && value && (
        <i className="far fa-copy ms-2 text-muted cursor-pointer fs-12"></i>
      )}
    </div>
  </div>
);

const TransactionDetailsModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      backdrop="static"
      title="Transaction Details"
      headerClassName="border-bottom pb-3"
    >
      {/* Sender Section */}
      <div className="mb-4">
        <h6 className="fw-bold text-black mb-3 fs-14">Sender</h6>
        <div
          className="bg-white rounded-4 p-4 border border-light"
          style={{ borderRadius: "12px" }}
        >
          <Row className="g-3">
            <Col md={2}>
              <InfoBlock label="Customer Type" value="Organization" />
            </Col>
            <Col md={3}>
              <InfoBlock
                label="Sender Name"
                value="SparkMinds Technology Pte Ltd"
              />
            </Col>
            <Col md={2}>
              <InfoBlock label="Customer ID" value="10844" />
            </Col>
            <Col md={3}>
              <InfoBlock label="ID Type" value="NRIC (Permanent Resident)" />
            </Col>
            <Col md={2}>
              <InfoBlock label="ID Number" value="S1234567A013" />
            </Col>
          </Row>
        </div>
      </div>

      {/* Beneficiaries Section */}
      <div className="mb-4">
        <h6 className="fw-bold text-black mb-3 fs-14">Beneficiaries</h6>
        <div
          className="bg-white rounded-4 p-4 border border-light overflow-hidden position-relative"
          style={{ borderRadius: "12px" }}
        >
          <div className="mb-4">
            <Badge
              bg="warning"
              className="bg-opacity-10 text-warning border-0 px-2 py-1 fw-bold fs-10 text-uppercase rounded-1"
            >
              Waiting for approval
            </Badge>
          </div>

          <Row className="g-0">
            <Col lg={8}>
              <Row className="g-4">
                <Col md={4}>
                  <InfoBlock
                    label="Transaction ID"
                    value="100006686"
                    showCopy={true}
                  />
                </Col>
                <Col md={4}>
                  <InfoBlock
                    label="Created Date & Time"
                    value="06/03/2026 18:38:32"
                  />
                </Col>
                <Col md={4}>
                  <InfoBlock label="Receiver Name" value="SparkMinds" />
                </Col>

                <Col md={4}>
                  <InfoBlock label="Receiver Type" value="Individual" />
                </Col>
                <Col md={4}>
                  <InfoBlock label="Receiving Method" value="Bank Transfer" />
                </Col>
                <Col md={4}>
                  <InfoBlock label="Bank/Agent" value="OMNIPAY, INC." />
                </Col>

                <Col md={4}>
                  <InfoBlock label="Country" value="Philippines" />
                </Col>
                <Col md={4}>
                  <InfoBlock
                    label="Account No/IBAN"
                    value="0552000003601"
                    showCopy={true}
                  />
                </Col>
                <Col md={4}>
                  <InfoBlock label="Address" value="--" />
                </Col>

                <Col md={4}>
                  <InfoBlock label="IFSC Code" value="--" />
                </Col>
                <Col md={4}>
                  <InfoBlock
                    label="Purpose of Transfer"
                    value="Loan Repayment"
                  />
                </Col>
                <Col md={4}>
                  <InfoBlock label="Source of Funds" value="Business" />
                </Col>
              </Row>
            </Col>
            <Col lg={4}>
              <div
                className="border p-4 h-100"
                style={{ borderRadius: "12px", backgroundColor: "#FAFAFA" }}
              >
                {[
                  { label: "Receiving Amount", value: "400.95 PHP" },
                  { label: "Exchange Rate", value: "1 SGD = 36.45 PHP" },
                  { label: "Send Amount", value: "11 SGD" },
                  { label: "Service Charge", value: "6 SGD" },
                  { label: "Promo", value: "0.00 SGD" },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between mb-3 border-bottom-dotted pb-2"
                  >
                    <span className="text-muted fs-11">{item.label}</span>
                    <span className="fw-bold text-black fs-12">
                      {item.value}
                    </span>
                  </div>
                ))}
                <div className="d-flex justify-content-between mt-4">
                  <span className="text-muted fs-11 fw-bold">Total Amount</span>
                  <span className="fw-bold text-black fs-14">17 SGD</span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Invoices Section */}
      <div className="mb-4">
        <h6 className="fw-bold text-black mb-3 fs-14">Invoices</h6>
        <div
          className="bg-white rounded-4 p-0 border border-light overflow-hidden position-relative"
          style={{ borderRadius: "12px" }}
        >
          <div
            className="bg-light bg-opacity-50 p-5 d-flex align-items-center justify-content-center overflow-auto"
            style={{ maxHeight: "400px" }}
          >
            <div className="shadow-sm border border-light p-1 bg-white">
              <img
                src="/api/placeholder/800/200"
                alt="Invoice Part"
                style={{ maxWidth: "100%", height: "auto", display: "block" }}
              />
            </div>
          </div>
          <div className="p-3 border-top d-flex justify-content-end align-items-center">
            <span className="fw-bold text-black fs-14">
              Total to Pay: 17 SGD
            </span>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default TransactionDetailsModal;
